import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = ['minutesDiv', 'transcriptionSourceInput']

    connect() {
        this.toggleMinutesField()
    }

    toggleMinutesField() {
        if (this.transcriptionSourceInputTarget.value === 'entire_call') {
            this.minutesDivTarget.hidden = true
        } else {
            this.minutesDivTarget.hidden = false
        }
    }
}
